import { ApiClient } from '@marketplace-web/core-api/api-client-util'
import { useApiGatewayClient } from '@marketplace-web/api-gateway/api-gateway-client-util'

import { GetInboxNotificationsArgs } from '../types/args'
import { GetUnreadInboxNotificationsCountResp, GetInboxNotificationsResp } from '../types/response'

const api = new ApiClient({
  baseURL: '/web/api/notifications',
  headers: { platform: 'web' },
})

export const getInboxNotifications = ({ page, perPage }: GetInboxNotificationsArgs) => {
  return api.get<GetInboxNotificationsResp>('/notifications', {
    params: {
      page,
      per_page: perPage,
    },
  })
}

export const useGetInboxNotificationsApiGateway = () => {
  const apiClient = useApiGatewayClient()

  return ({ page, perPage }: GetInboxNotificationsArgs) =>
    apiClient.get<GetInboxNotificationsResp>('/inbox-notifications/v1/notifications', {
      params: {
        page,
        per_page: perPage,
      },
    })
}

export const getUnreadInboxNotifications = () =>
  api.get<GetUnreadInboxNotificationsCountResp>('/notifications/unread_count')

export const useGetUnreadInboxNotificationsApiGateway = () => {
  const apiClient = useApiGatewayClient()

  return () =>
    apiClient.get<GetUnreadInboxNotificationsCountResp>(
      '/inbox-notifications/v1/notifications/unread_count',
    )
}
